module.exports = __webpack_public_path__ + "img/IMG_6070_L.d6b580a3.webp";